import { render, staticRenderFns } from "./RankingPlayerParts.vue?vue&type=template&id=b93e6c10&scoped=true"
import script from "./RankingPlayerParts.vue?vue&type=script&lang=ts"
export * from "./RankingPlayerParts.vue?vue&type=script&lang=ts"
import style0 from "./RankingPlayerParts.vue?vue&type=style&index=0&id=b93e6c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93e6c10",
  null
  
)

export default component.exports